import _ from "lodash";

const initialState = {
  listProviderError: [],
  listProviderLoader: false,
  listProviderResponse: null,
};
const providerErrorReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_LIST_PROVIDER_ERROR_ACTION":
      return { ...state, listProviderError: action.payload };
    case "SHOW_LIST_PROVIDER_ERROR_LOADER":
      return { ...state, listProviderLoader: true };
    case "HIDE_LIST_PROVIDER_ERROR_LOADER":
      return { ...state, listProviderLoader: false };

    default:
      return state;
  }
};

export default providerErrorReducer;
